// blog page navigation tabs
// if(document.querySelector('#blog-nav-by-tags')){  
//   const blog_tabs = document.querySelector('#blog-nav-by-tags');
//   const all_LI_in_blog_tabs = blog_tabs.querySelectorAll('li');
//   all_LI_in_blog_tabs.forEach(tab=>{
//     if(tab){
//       tab.addEventListener('click',()=>{
//         all_LI_in_blog_tabs.forEach(all_tab=>{
//           if(all_tab.classList.contains('active')){            
//             all_tab.classList.remove('active');
//           }
//         });
//         tab.classList.add('active');
//       });
//     }
//   });
// }

if (document.querySelector('#blog-nav-by-tags')) {
    const blog_tabs = document.querySelector('#blog-nav-by-tags');
    const all_LI_in_blog_tabs = blog_tabs.querySelectorAll('li');

    const handleClick = (tab) => {
        all_LI_in_blog_tabs.forEach(all_tab => {
            all_tab.classList.remove('active');
        });
        tab.classList.add('active');
        sessionStorage.setItem('activeTabId', tab.id);
    };
    all_LI_in_blog_tabs.forEach(tab => {
        if (tab) {
            tab.addEventListener('click', () => {
                handleClick(tab);
            });
        }
    });

    const activeTabId = sessionStorage.getItem('activeTabId');
    if (activeTabId) {
        const activeTab = document.getElementById(activeTabId);
        if (activeTab) {
            handleClick(activeTab);
        }
    }
}

// mute/unmute Review Section Homepage
 const video_review_main = document.querySelectorAll('.customer-item');
  video_review_main.forEach((video)=>{
    if(video){
      const videoTag = video.querySelector('video');
      const MuteIcon = video.querySelector('.product_new__testimonials__mute_icon');
      const UnmuteIcon = video.querySelector('.product_new__testimonials__unmute_icon');
      if(videoTag){        
        videoTag.addEventListener('click',()=>{
          if(video.querySelector('.play-button') || video.querySelector('.pause-button')){
            return false;
          } else{            
            if(videoTag.paused){
              videoTag.play();
            } else{
              videoTag.pause();
            }
          }
        })
      }
      if(UnmuteIcon){        
        UnmuteIcon.addEventListener('click',()=>{
          video_review_main.forEach((mute)=>{
            if(mute.querySelector('video')){                
              mute.querySelector('video').muted = true;
            }
            if(mute.querySelector('.product_new__testimonials__mute_icon')){mute.querySelector('.product_new__testimonials__mute_icon').style.display = "none";}
            if(mute.querySelector('.product_new__testimonials__unmute_icon')){mute.querySelector('.product_new__testimonials__unmute_icon').style.display = "";}
          })
          videoTag.muted = false;
          UnmuteIcon.style.display = "none";
          MuteIcon.style.display = "";
        })
      }
      if(MuteIcon){        
        MuteIcon.addEventListener('click',()=>{
          videoTag.muted = true;
          MuteIcon.style.display = "none";
          UnmuteIcon.style.display = "";
        })
      }
    }
  })

$(function() {
	var iframe = $('#player1')[0];

    if (iframe) {
        var player = new Vimeo.Player(iframe);
        var status = $('.status');
    
        player.on('pause', function() {
            status.text('paused');
        });
    
        player.on('ended', function() {
            status.text('ended');
        });
    
        player.on('timeupdate', function(data) {
            status.text(data.seconds + 's played');
        });
    
        $('button').on('click', function() {
            var method = $(this).text().toLowerCase();
            player[method]();
        });
    }
});


// function accordianToggle (){  
//     if(window.innerWidth < 992){    
//       const main_Div = document.querySelectorAll('.accordionItem');
//       main_Div.forEach(div=>{
//         div.addEventListener('click',()=>{
//           div.classList.toggle('open');
//           if(div.classList.contains('open')){
//             div.classList.remove('close');
//           } else{
//             div.classList.add('close');
//           }
//         })
//       })
//     } else{
//       var accItem = document.getElementsByClassName('accordionItem');
//       var accHD = document.getElementsByClassName('accordionItemHeading');
//       for (i = 0; i < accHD.length; i++) {
//           accHD[i].addEventListener('click', toggleItem, false);
//       }
//       function toggleItem() {
//           var itemClass = this.parentNode.className;
//           for (i = 0; i < accItem.length; i++) {
//               accItem[i].className = 'accordionItem close';
//           }
//           if (itemClass == 'accordionItem close') {
//               this.parentNode.className = 'accordionItem open';
//           }
//       }
//     }
// }

document.addEventListener("DOMContentLoaded", (event) => {
  // accordianToggle();
  var accItem = document.getElementsByClassName('accordionItem');
  var accHD = document.getElementsByClassName('accordionItemHeading');
  for (i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', toggleItem, false);
  }
  function toggleItem() {
      var itemClass = this.parentNode.className;
      for (i = 0; i < accItem.length; i++) {
          accItem[i].className = 'accordionItem close';
      }
      if (itemClass == 'accordionItem close') {
          this.parentNode.className = 'accordionItem open';
      }
  }
});

 var swiper = new Swiper('.user_slider', {
  centeredSlides: false,
  loop: true,
  slidesPerView: 2,
   speed:2000,
    autoplay: {
      delay: 0, 
      disableOnInteraction: false,
     },
      spaceBetween: 20,
       pagination: {
    clickable: true
  },
       breakpoints: {
    768: {
       slidesPerView: 2.2,
      spaceBetween: 30
    },
    991: {
      slidesPerView: 3.5,
      spaceBetween: 30
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 30
    }
  }
  });


window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`[data-equal]`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}

window.setGridHeight('.image-text-cover'); 

const calculateAccordionContentHeight = (target) => {
    const updateHeight = () => {
        if (target) {
            const heading = target.querySelector(".accordionItemModal__heading");
            const content = target.querySelector(".accordionItemContent");
            
            if (heading && content) {
                content.style.cssText = `--accordion-heading-height: ${heading.offsetHeight}px`;
            }
        }
    }
    
    updateHeight();
    window.addEventListener('resize', updateHeight);
}

document.addEventListener("click", (e) => {
    if (e.target.closest("[data-accordion-modal-opener]")) {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
        calculateAccordionContentHeight(e.target.closest("[data-accordion-modal-opener]"));
    }

    if (e.target.closest(".accordionItemModal__close, .accordionItemContentBackdrop")) {
        const item = e.target.closest(".accordionItem");
        item.className = "accordionItem close";
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
    }

    if (!e.target.closest(".w-dropdown, .w--open, .w--open *")) {
        const dropEls = document.querySelectorAll(".w-dropdown-toggle, .w-dropdown-list");

        if (dropEls && dropEls.length > 0) {
            [...dropEls].map(el => {
                if (el.classList.contains("w--open")) {
                    el.classList.remove("w--open");
                }

                return el;
            })
        }
    }

    if (e.target.closest(".w-dropdown")) {
        const dropdown = e.target.closest(".w-dropdown");
        const toggle = dropdown.querySelector(".w-dropdown-toggle");
        const list = dropdown.querySelector(".w-dropdown-list");

        if (dropdown) {
            if (toggle) {
                toggle.classList.toggle("w--open");
            }
    
            if (list) {
                list.classList.toggle("w--open");
            }
        }
    }

    if (e.target.closest("[data-tab-button]:not(.w--tab-active)")) {
        const currentEl = e.target.closest("[data-tab-button]");
        const tabId = currentEl.getAttribute("data-tab-button");
        const wrapper = currentEl.closest("[data-tab-wrapper]");
        const currentTab = wrapper.querySelector(`[data-tab-el='${tabId}']`);

        [...wrapper.querySelectorAll("[data-tab-button], [data-tab-el]")].map(el => {
            el.classList.remove("w--current");
            el.classList.remove("w--tab-active");
            return el;
        });

        currentEl.classList.add("w--current");
        
        if (currentTab) {
            currentTab.classList.add("w--tab-active");
        }
    }
});

(function fixPageTitle() {
    const pageTitle = document.title;
    const h1Element = document.querySelector("h1");

    if (h1Element && h1Element.innerText === pageTitle) {
        const pageType = window.request.page_type;

        if (pageType) {
            document.title = `${pageTitle} | ${pageType}`;
        }
    }
})();

if (!window.customElements.get('announce-timer')) {
  class AnnounceTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.startDate = this.dataset.startDate;
    }

    connectedCallback() {
      const daysEl = this.querySelector('[data-timer-days]');
      const hourEl = this.querySelector('[data-timer-hours]');
      const minuteEl = this.querySelector('[data-timer-minutes]');
      const secondEl = this.querySelector('[data-timer-seconds]');

      const targetTime = new Date(this.startDate).getTime();

      if (isNaN(targetTime)) {
        return;
      }

      const updateTimer = () => {
        const now = new Date().getTime();
        const distance = targetTime - now;

        if (distance <= 0) {
          clearInterval(this.interval);
          daysEl.textContent = '00';
          hourEl.textContent = '00';
          minuteEl.textContent = '00';
          secondEl.textContent = '00';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(2, '0');
        hourEl.textContent = String(hours).padStart(2, '0');
        minuteEl.textContent = String(minutes).padStart(2, '0');
        secondEl.textContent = String(seconds).padStart(2, '0');
      };

      updateTimer();
      this.interval = setInterval(updateTimer, 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  window.customElements.define('announce-timer', AnnounceTimer);
}